"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _ActionMenuList = _interopRequireDefault(require("./ActionMenuList"));

var _ActionMenuItem = _interopRequireDefault(require("./ActionMenuItem"));

var _ActionMenuLink = _interopRequireDefault(require("./ActionMenuLink"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class NavActionMenu extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      menuByUrl: {}
    });

    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (prevProps.menuByUrl !== this.props.menuByUrl) {
        this.getMenuByUrl();
      }

      if (prevProps.currentUrl !== this.props.currentUrl) {
        this.getCurrentUrl();
      }
    });

    _defineProperty(this, "getMenuByUrl", () => {
      const menuByUrl = this.props.menuByUrl;
      this.setState({
        menuByUrl: menuByUrl
      });
    });

    _defineProperty(this, "getCurrentUrl", () => {
      const currentUrl = this.props.currentUrl;
      this.selectMenuByUrl(currentUrl);
    });

    _defineProperty(this, "selectMenuByUrl", url => {
      let menuByUrl = this.state.menuByUrl;
      this.setState({
        currentUrl: url,
        menuByUrl: _extends({}, menuByUrl, {
          [url]: _extends({}, menuByUrl[url], {
            expanded: true
          })
        })
      });
    });

    _defineProperty(this, "getMenuItem", item => {
      const _this$state = this.state,
            menuByUrl = _this$state.menuByUrl,
            currentUrl = _this$state.currentUrl;
      const selected = item.url && currentUrl == item.url || item.selected || false;

      if (item.url && menuByUrl[item.url]) {
        item = _extends({}, item, {}, menuByUrl[item.url], {
          selected: selected
        });
      }

      return item;
    });

    _defineProperty(this, "onSelect", item => {
      const url = item.url;
      url && this.selectMenuByUrl(url);

      if (this.props.onSelect) {
        this.props.onSelect(item);
      }
    });

    _defineProperty(this, "onToggle", item => {
      const url = item.url,
            expanded = item.expanded;
      const menuByUrl = this.state.menuByUrl;
      this.setState({
        menuByUrl: _extends({}, menuByUrl, {
          [url]: _extends({}, item, {}, menuByUrl[url], {
            expanded: !expanded
          })
        })
      });

      if (this.props.onToggle) {
        this.props.onToggle(item);
      }
    });

    _defineProperty(this, "renderLink", item => {
      const selected = item.selected,
            url = item.url,
            icon = item.icon,
            title = item.title,
            label = item.label,
            description = item.description,
            count = item.count;
      return _react.default.createElement(_ActionMenuLink.default, {
        selected: selected,
        url: url,
        icon: icon,
        label: label || title,
        description: description,
        count: count,
        onClick: () => this.onSelect(item)
      });
    });

    _defineProperty(this, "renderItem", (item, index) => {
      item = this.getMenuItem(item);
      const _item = item,
            role = _item.role,
            children = _item.children,
            hidden = _item.hidden,
            selected = _item.selected;
      const expanded = true;

      if (hidden) {
        return _react.default.createElement(_ActionMenuItem.default, {
          role: role
        }, _react.default.createElement(_ActionMenuList.default, {
          role: role
        }, children && children.map(this.renderItem)));
      }

      if (children) {
        return _react.default.createElement(_ActionMenuItem.default, {
          role: role || "treeitem",
          selected: selected,
          expanded: expanded,
          onToggle: () => this.onToggle(item)
        }, this.renderLink(item), children && expanded && _react.default.createElement(_ActionMenuList.default, {
          role: "tree"
        }, children && children.map(this.renderItem)));
      }

      return _react.default.createElement(_ActionMenuItem.default, _extends({}, item, {
        role: role || "none",
        key: index
      }), this.renderLink(item));
    });
  }

  componentDidMount() {
    this.getMenuByUrl();
  }

  render() {
    const _this$props = this.props,
          className = _this$props.className,
          menu = _this$props.menu;

    if (!menu || !menu.length) {
      return false;
    }

    return _react.default.createElement("nav", {
      className: className
    }, _react.default.createElement(_ActionMenuList.default, {
      role: "tree"
    }, menu.map(this.renderItem)));
  }

}

_defineProperty(NavActionMenu, "defaultProps", {
  selectedUrl: undefined,
  menu: [],
  menuByUrl: {},
  datetime: ""
});

NavActionMenu.propTypes = process.env.NODE_ENV !== "production" ? {
  currentUrl: _propTypes.default.string,
  menu: _propTypes.default.array,
  menuByUrl: _propTypes.default.object,
  onSelect: _propTypes.default.func
} : {};
var _default = NavActionMenu;
exports.default = _default;
module.exports = exports.default;